import React from "react"
import ComparisonLanding from "./landing"
import ComparisonFeatureBreakdown from "./feature-breakdown"
import { CompetitorCopy } from "./resources/_copy-template"
import TestimonialBanner from "../home/testimonials/banner"
import AllCreatures from "~images/pages/home/testimonials/all-creatures.png"
import ComparisonParagraph from "./comparison-paragraph"
// import MigrationOffer from "./migration-offer"
import FAQSection from "../home/faq"
import BookACallWithZach from "./call-zach"

const ComparisonView: React.FC<{ copy: CompetitorCopy }> = ({ copy }) => {
    return (
        <>
            <ComparisonLanding
                companyName={copy.company}
                copy={copy["landing"]}
            />
            {/* <TestimonialBanner
                headshot={AllCreatures}
                name="Colin Hebert, Co-Founder"
                location="Chckvet, Inc."
                featured=""
            >
                Plain & simple, the only reason people switch to Chckvet is
                because we offer more features at a lower cost AND we have the
                best scheduling & analytics in the veterinary space.
            </TestimonialBanner> */}
            <ComparisonParagraph copy={copy["landing"]} />
            <ComparisonFeatureBreakdown copy={copy["features"]} />
            <TestimonialBanner
                headshot={AllCreatures}
                name="Luke Mann, Practice Manager"
                location="All Creatures Veterinary Clinic, Inc, Princeton, WV"
                featured="Working with Chckvet has been a dream."
            >
                I've been here for 2 years and we've gone through 4 different
                apps. We've had a lot of issues & trying to get things fixed is
                a nightmare. Chckvet is always quick to fix things, open to
                change, and making sure that we get what we need. And that has
                been fantastic.
            </TestimonialBanner>
            <BookACallWithZach />
            <FAQSection notOnHome />
            {/* <MigrationOffer companyName={copy.company} /> */}
        </>
    )
}

export default ComparisonView
